"use strict";

const ageGate = document.getElementById("ageGate");
const ageAccept = document.getElementById("ageAccept");

if (ageGate) {
  const ageVerified = localStorage.getItem("aphro-age-verified");

  if (ageVerified === "true") {
    ageGate.classList.add("is-hidden");
  }

  if (ageAccept) {
    ageAccept.addEventListener("click", () => {
      localStorage.setItem("aphro-age-verified", "true");
      ageGate.classList.add("is-hidden");
    });
  }
}